import { fetchApi } from '@/config/axiosSetting';
import {
  GetFabAdditionalImagesQueryFunctionParamsType,
  GetFabAdditionalImagesQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQuery.type';

export const getFabAdditionalImagesFunction = (
  params: GetFabAdditionalImagesQueryFunctionParamsType,
): Promise<GetFabAdditionalImagesQueryResponseType> => {
  return fetchApi.get(params.url, { params: { damaged_id: params.damagedId } });
};
